import { mapState } from "vuex";
import CryptoJS from "crypto-js";
import axios from "axios";
const Base64 = require("js-base64").Base64;

export default {
  data() {
    return {
      // 公用
      Configuration: {
        headers: {
          "sign-algorithm": "HMAC-SHA256",
          "sign-appid": process.env.VUE_APP_APPID,
          "sign-timestamp": "",
          "sign-signature": "",
        },
        formData: {
          appid: process.env.VUE_APP_APPID,
        },
        SecretKey: process.env.VUE_APP_SECRET,
      },
      // 其他
      isLoading: false,
      // 接口列表
      reqFnList: {
        // 账号登录
        account: {
          url: "sdk/account-login",
          method: "post",
        },
        // 账号注册
        signIn: {
          url: "sdk/account-register",
          method: "post",
        },
        updatePassword: {
          url: "sdk/update-passwd",
          method: "post",
        },
        getPhoneCode: {
          url: "sdk/phone-code",
          method: "post",
        },
      },
      // 登录相关
      SDKURL: process.env.VUE_APP_SDKURL,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  async created() {
  },
  watch: {},
  mounted() {},
  methods: {
    // 接口请求
    loginTyLogin(reqUrl, url, queryData = {}) {
      let that = this;
      return new Promise((resolve, reject) => {
        this.isLoading = true;
        let method = this.reqFnList[url].method;
        let timestamp = parseInt(new Date().getTime() / 1000);
        let data = JSON.parse(JSON.stringify(this.Configuration));
        data.headers["sign-timestamp"] = timestamp;
        this.timestamp = timestamp;
        let formData = {
          ...data.formData,
          ...queryData,
        };
        let str = data.headers["sign-algorithm"] + data.headers["sign-timestamp"] + data.headers["sign-appid"] + (method == "post" ? JSON.stringify(formData) : "");
        data.headers["sign-signature"] = this.get_sha256(str, data.SecretKey);
        axios({
          method: method,
          url: reqUrl + this.reqFnList[url].url,
          headers: {
            ...data.headers,
          },
          data:
            method == "post"
              ? {
                  ...formData,
                }
              : {},
          params:
            method == "get"
              ? {
                  ...formData,
                }
              : {},
        })
          .then((res) => {
            if (res.status == 200) {
              if (res.data.code !== 200 && res.data.status !== 200) {
                this.$message.error(res.data.message);
              }
              that.isSubmit = false;
              resolve(res.data);
            }
          })
          .finally(() => {
            that.isLoading = false;
          });
      });
    },
    get_sha256(str, secret) {
      var signature = CryptoJS.HmacSHA256(str, secret).toString();
      signature = Base64.encode(signature);
      return signature;
    },
  },
};
